import { createBrowserRouter, RouterProvider as RRRouterProvider } from 'react-router-dom';

import { routes } from './routes';

const router = createBrowserRouter(routes, {
  future: {
    v7_relativeSplatPath: true,
  },
});

export function RouterProvider() {
  return <RRRouterProvider router={router} />;
}
